import transientChartModelMaker from './transientChartModelMaker';
import transientModelChart from './transientModelChart';

angular
    .module('signalview.chartMaker', [])
    .component('transientModelChart', transientModelChart)
    .service('transientChartModelMaker', transientChartModelMaker);
